import {
    createIconText,
    IconText,
} from '@vfde-brix/ws10/icon-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Mounts an IconText by ID
 */
export const mountIconText = (containerId: string): IconText | null => {
    const containerElement = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!containerElement) {
        return null;
    }

    const iconText = createIconText(containerElement, NO_PATTERN_BUSINESS_LOGIC);

    return iconText;
};
